import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";
import * as React from "react";

export default function ConfirmationDialog({
  id = "confirmation-dialog-description",
  open,
  title,
  description,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  keepMounted = false,
  transition = "up",
  loading = false,
  // TODO: Implement this
}) {
  const Transition = React.useMemo(
    () =>
      React.forwardRef(function Transition(props, ref) {
        return <Slide direction={transition} ref={ref} {...props} />;
      }),
    [transition]
  );

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-describedby={id}
      keepMounted={keepMounted}
      TransitionComponent={Transition}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id={id}>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" style={{color:"#005cff"}} onClick={onCancel}>{cancelText}</Button>
        <Button variant="contained" style={{ color: "white",background:"#005cff" }} onClick={onConfirm}>{confirmText}</Button>
      </DialogActions>
    </Dialog>
  );
}
